//API CONSTANTS
const APP = "app";
//ROOT API
export const ROOT_API_ENDPOINTS = {
  GENERATEOTP: "/otp",
  VERIFYOTP: `/verifyOTP`,
};
//LOS API ENDPOINTS
export const LOS_API_ENDPOINTS = {
  MASKEDACCOUNT: "/maskedaccount",
  CONSENT: "/consent",
  VPALIST: "/vpalist",
  MASTER_API_ENDPOINTS: {
    PURPOSE_OF_LOAN: "/purposeofloan",
    MARITAL_STATUS: "/maritalstatus",
    LANGUAGE: "/language",
    INDUSTRY_TYPE_DETAILS: "/industrytype-details",
    EMPlOYEE_TYPE_DETAILS: "/employeetype-details",
    EDUCATION: "/education",
    COMPANY_NAME_DETAILS: "/companyname-details",
    GENDER: "/gender",
    APPLICATION_CONFIG: "/application-config",
  },
  OFFICALEMAIL_ENDPOINTS: (appId) => {
    return {
      VERIFY_EPFO_MAIL: `/${APP}/${appId}/workemail`,
    };
  },
  EMAIL_OTP_ENDPOINTS: (appId) => {
    return {
      SEND_EMAIL_OTP: `/${APP}/${appId}/generate-email-otp`,
      VERIFY_EMAIL_OTP: `/${APP}/${appId}/verify-email-otp`,
    };
  },
  DIGIKYC_CONSENT: (appId) => `/${APP}/${appId}/digikycconsent`,

  //
  ADDRESS_ENDPOINTS: (appId) => {
    return {
      GET_ADDRESS: "/address",
      MUTATE_ADDRESS: `/${APP}/${appId}/address`,
      UPDATE_ADDRESS_RL: `/${APP}/${appId}/rladdress`,
      CONFIRM_ADDRESS_RL: `/${APP}/${appId}/address-confirm`,
    };
  },
  APPLICATION_ENDPOINTS: (appId, stage) => {
    return {
      APPLICATION: "/application",
      LOAN_AMOUNT: `/${APP}/${appId}/loanamount`,
      APP_STAGE_CONFIG: `/${APP}/${appId}/configs/${stage}`,
    };
  },
  CKYC_ENDPOINTS: (appId) => {
    return {
      SEND_OTP: `/${APP}/${appId}/ckyc/sendOTP`,
      VALIDATE_OTP: `/${APP}/${appId}/ckyc/validateOTP`,
      SKIP_CKYC: `/${APP}/${appId}/ckyc/skip/consent`,
      CKYC: `/${APP}/${appId}/ckyc`,
      CKYC_IMAGE: `/ckyc-image?appId=${appId}`,
      SELECT_ADDRESS: `/${APP}/${appId}/ckyc/select-current-add`,
      DIGI_KYC_REDIRECT_URL: `/${APP}/${appId}/ckyc/redirectionURL`,
    };
  },
  KYC_TOKEN_ENDPOINT: () => `/app/gethypertoken`,

  CUSTOMER_ENDPOINTS: (appId) => {
    return {
      CUSTOMER: "/customer",
      CUSTOMER_PERSONAL_DETAILS: `/${APP}/${appId}/personaldetails`,
    };
  },
  PAN: (appId) => `/${APP}/${appId}/pan`,
  WORK_DETAILS: (appId) => `/${APP}/${appId}/workdetails`,
  MANDATE_ENDPOINTS: (appId) => {
    return {
      REPAYMENT_SETUP: `/${APP}/${appId}/repaymentsetup`,
      MATCH_ACCOUNT_NUMBER: `/${APP}/${appId}/maskedaccount`,
      MANDATE_MODES: `/${APP}/${appId}/mandatemodes`,
    };
  },
  LEEGALITY_ENDPOINTS: (appId) => {
    return {
      RELATIONS: `/relations`,
      ESIGN: `/${APP}/${appId}/esign`,
      NOMINEE_DETAILS: `/${APP}/${appId}/nomineedetails`,
    };
  },
  CREDIT_SCORE_ENDPOINT: () => {
    return {
      CUSTOMER_STATUS: `/credit-score/customer/status`,
      PAN_DETAILS: `/credit-score/pan-details`,
      VERIFY_PAN_STATUS: `/credit-score/pan?consent=true&consentType=PAN`,
      CREDIT_DASHBOARD_LAST: `/credit-score/customer/last-record`,
      CREDITSCORE_DASHBOARD_LATEST: `/credit-score/customer/latest-record`,
      CREDITSCORE_DASHBOARD_LATEST_REFRESH: `/credit-score/customer/latest-record?refreshScore=true`,
    };
  },
  CHECK_ELIGIBILITY_ENDPOINT: () => {
    return {
      CHECK_ELIGIBILITY_STATUS: `/eligibility/status`,
      PAN_DETAILS: `/eligibility/pan`,
      CHECK_ELIGIBILTY_OFFER: `/eligibility/offer`,
    };
  },
  MAPPLS_ENDPOINT: () => {
    return {
      REVERSE_GEOCODE: `/mappls/reverse-geocode`,
    };
  },
  EKYC_ENDPOINTS: (appId) => {
    return {
      EKYC_CONSENT: `/v1/${APP}/${appId}/ekycconsent`,
    };
  },
  
};

//INTERNAL API ENDPOINTS
export const INTERNAL_API_ENDPOINTS = {
  RPD: (appId) => `/${APP}/${appId}/reversepennydrop`,
  VKYC_DETAILS: (appId) => `/${APP}/${appId}/vkycdetails`,
  VKYC_CREATE: (appId) => `/${APP}/${appId}/createvkyc`,
  LEEGALITY_ENDPOINTS: (appId) => {
    return {
      LEEGALITY: `/${APP}/${appId}/legality`,
      LEEGALITY_STATUS: `/${APP}/${appId}/legality-status`,
    };
  },
  MANDATE_ENDPOINTS: (appId) => {
    return {
      UPI_MANDATE: `/${APP}/${appId}/upimandate`,
      UPI_MANDATE_STATUS: `/${APP}/${appId}/upimandatestatus`,
      BANK_MANDATE_STATUS: `/${APP}/${appId}/mandatestatus`,
      BANK_MANDATE: `/${APP}/${appId}/mandate`,
      JUSPAY_ORDER_STATUS: `/juspay/order/${appId}/status`,
    };
  },
  PERFIOS: "perfios",
  PENNY_DROP: (appId) => `/${APP}/${appId}/penny-drop-banking`,
  OFFERS_ENDPOINTS: (appId) => {
    return {
      OFFERS: "offers",
      SELECT_OFFER: `/${APP}/${appId}/selectoffer`,
      GET_OFFER: `/offers?appId=${appId}`,
      GET_OFFER_RL: `/${APP}/fetchrepeatloanoffer?appId=${appId}`,
      // SELECT_SLIDER_OFFER: `/${APP}/${appId}/offersDetails`,
      SELECT_SLIDER_OFFER: `/${APP}/${appId}/offerDetailsWithRoi`,
      SELECT_SLIDER_OFFER_RL: `/${APP}/${appId}/rlofferDetailsWithRoi`,
      EDIT_SELECTED_OFFER: `/${APP}/${appId}/selected-offer`,
      EDIT_SELECTED_OFFER_RL: `/${APP}/${appId}/selected-rloffer`,
    };
  },
  INSURANCE_ENDPOINT: (body) => {
    return {
      INSURANCE: `/${APP}/${body?.appId}/insurance`,
      GET_INSURANCE: `/${APP}/${body?.appId}/insurance${
        body.params ? `?${body.params}` : ``
      }`,
    };
  },
  MULTI_BUREAU_ENDPOINT: (appId) => `/mbureau/${appId}`,
  KYC_ENDPOINT: (appId) => `/${APP}/${appId}/digikyc`,
  HIGHER_AMOUNT_ENDPOINT: (appId) => `/${APP}/${appId}/higheramount`,
  BANK_ENDPOINTS: () => {
    return {};
  },
  CHECK_PAN_LINKING_STATUS: (appId) =>
    `/${APP}/${appId}/pan-aadhaar-link-status`,
  IFSC_ENDPOINTS: (body) => {
    return {
      GET_BANKS_NAME_LIST: `/bankname`,
      GET_BANKS_LIST: `/getIFSCBanks`,
      GET_IFSC_BANKS_STATE: `/getIFSCBanksState?bankName=${body?.bankName}`,
      GET_IFSC_BANKS_CITY: `/getIFSCBanksCities?bankName=${body?.bankName}&state=${body?.state}`,
      GET_IFSC_BANKS_AREA: `/getIFSCBanksAddress?bankName=${body?.bankName}&state=${body?.state}&city=${body?.city}`,
      GET_IFSC_BANKS: `/getIFSCBanksIfsc?bankName=${body?.bankName}&state=${body?.state}&city=${body?.city}&address=${body?.address}`,
    };
  },
  RPD_MODES: (appId) => `/${APP}/${appId}/rpdmodes`,
  RPD_STATUS: (appId) => `/${APP}/${appId}/reverse-penny-drop-details`,
  TRIGGER_UCIC: (appId, stage) => `/${APP}/${appId}/trigger-ucic/${stage}`,
  PRODUCT_DETAILS: {
    LoanDetails: "/loandetails",
  },
  EKYC_ENDPOINTS: (appId) => {
    return {
      EKYC_INITIATE: `/ekyc/initiate`,
      EKYC_COMPLETE: `/ekyc/complete`,
      EKYC_STATUS: `/${APP}/${appId}/ekyc/status`,
    };
  },
};

//TAGS
export const RTK_TAGS = {
  AUTH_TAG: "auth",
  DIGIKYC_TAG: "digikyc",
  APPLICATION_TAG: "application",
  CUSTOMER_TAG: "customer",
  MY_LOANS_TAG: "myloans",
  LOAN_DETAILS_TAG: "loandetails",
  ADDRESS_TAG: "address",
  INSURANCE_TAG: "insurance",
  APP_STAGE_CONFIG_TAG: "appstageconfig",
  CREDIT_SCORE: "creditscore",
};
